import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    destinationData: Object,
    interactive: { type: Boolean, default: false },
    zoomToState: { type: Boolean, default: true }
  }

  connect() {
    this.customerMarker = null
    this.mapMarkers = []
    this.geocodedAddress = null
    this.geocoder = new google.maps.Geocoder()

    this.initMap()
  }

  async initMap() {
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 41.215, lng: -96.112 },
      zoom: 4,
      fullscreenControl: false,
      gestureHandling: this.interactiveValue == true ? "" : "none",
      zoomControl: this.interactiveValue || false,
    })
    this.mapIw = new google.maps.InfoWindow()
    this.oms = new OverlappingMarkerSpiderfier(this.map, {
      markersWontMove: true,
      markersWontHide: true,
      basicFormatEvents: true,
      keepSpiderfied: true
    });

    if (this.destinationDataValue.address || this.destinationDataValue.city || this.destinationDataValue.state || this.destinationDataValue.zipcode) {
      await this.fetchGeocodedAddress()
      this.addCustomerMarker()
      this.zoomToState()
    }
  }

  async fetchGeocodedAddress() {
    const address = `${this.destinationDataValue.address} ${this.destinationDataValue.city}, ${this.destinationDataValue.state} ${this.destinationDataValue.zipcode}`.trim().replace(" , ", "").replace("null, ", "").replace("null ", "").replace("undefined, ", "").replace("undefined ", "")

    let response = await this.geocoder.geocode({ 'address': address })
    let result = response.results[0]
    this.geocodedAddress = result
    return result
  }

  addCustomerMarker() {
    const marker = new google.maps.Marker({ position: { lat: this.geocodedAddress.geometry.location.lat(), lng: this.geocodedAddress.geometry.location.lng() }, icon: { url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png', scaledSize: new google.maps.Size(40, 40) }, optimized: true })
    google.maps.event.addListener(marker, 'spider_click', (e) => {
      this.mapIw.setContent("<div class='mb-2 text-lg font-semibold'>Customer:</div><p>" + this.geocodedAddress.formatted_address + "</p><p>" + this.destinationDataValue.title+"</p>")
      this.mapIw.open(this.map, marker)
    })
    this.oms.addMarker(marker)
    this.customerMarker = marker
  }

  async zoomToState() {
    const stateComponent = this.geocodedAddress.address_components.find((component) => component.types.includes("administrative_area_level_1"))
    const state = stateComponent && stateComponent.long_name
    if (state) {
      const response = await this.geocoder.geocode({ 'address': state.trim() })
      const result = response.results[0]

      this.map.fitBounds(result.geometry.viewport)
    }
  }

}